import {
    IonCardSubtitle,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonModal,
    IonPage,
    IonTitle,
    IonToolbar,
    useIonViewWillEnter
} from "@ionic/react";
import Lightning from "assets/icons/Lightning";
import SquareLogo from "assets/icons/Square";
import useMerchantProfile from "hooks/useMerchantProfile";
import {
    addOutline,
    businessOutline, documentOutline, helpOutline, informationOutline, lockClosedOutline, personOutline
} from "ionicons/icons";
import React, { useContext, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import "./Account.css";
import Privacy from "./Account/Privacy";
import Terms from "./Account/Terms";

const Account: React.FC = () => {
    const { authState, logout } = useContext(AuthContext);
    const [showPrivacy, setShowPrivacy] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const { data, refetch } = useMerchantProfile(authState.user.uid, true);

    useIonViewWillEnter(() => {
        refetch();
    })
    
    return (
        <IonPage className={'account-page-root'}>
            <IonHeader className={"ion-no-border"}>
                <IonToolbar className={"background-color"}>
                    <IonTitle>Profile</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar className={"background-color"}>
                        <IonTitle size="large">Your profile</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonList lines="none">
                    <IonListHeader lines="none">
                        <IonCardSubtitle>General</IonCardSubtitle>
                    </IonListHeader>
                    <IonItem routerLink={'/account/business'}>
                        <IonIcon slot="start" size="small"icon={businessOutline} />
                        <IonLabel>Business</IonLabel>
                    </IonItem>
                    {data && data.merchants?.length > 0 
                        && data.merchants[0].business_name &&<IonItem routerLink={'/account/lsp'}>
                        <div slot="start">
                        <Lightning height={18} fill={"#f2a900"} />
                        </div>
                        <IonLabel>Lightning Service Providers</IonLabel>
                    </IonItem>}
                    <IonItem routerLink={'/account/square'}>
                        <div slot="start" className={"inverted"}>
                            <SquareLogo height={18} />
                        </div>
                        <IonLabel>Connect Your Square Account</IonLabel>
                    </IonItem>
                    <IonItem routerLink={'/account/personal'}>
                        <IonIcon slot="start" size="small"icon={personOutline} />
                        <IonLabel>Personal</IonLabel>
                    </IonItem>
                    {/* {data && data.merchants?.length > 0 
                        && (data.merchants[0].opennode_account_id 
                            || data.merchants[0].opennode_key_public 
                                || data.merchants[0].provider_key 
                                    || data?.merchants[0]?.provider_keys?.length > 0) &&
                    <IonItem routerLink={'/account/withdrawals'}>
                        <IonIcon slot="start" size="small"icon={cashOutline} />
                        <IonLabel>Withdrawals</IonLabel>
                    </IonItem>} */}
                    <IonListHeader lines="none">
                        <IonCardSubtitle>Feedback</IonCardSubtitle>
                    </IonListHeader>
                    <IonItem routerLink={'/account/faq'}>
                        <IonIcon slot="start" size="small"icon={helpOutline} />
                        <IonLabel>Frequently asked questions</IonLabel>
                    </IonItem>
                    <IonItem routerLink={'/account/support'}>
                        <IonIcon slot="start" size="small"icon={informationOutline} />
                        <IonLabel>Support center</IonLabel>
                    </IonItem>
                    <IonItem routerLink={'/account/suggestion'}>
                        <IonIcon slot="start" size="small"icon={addOutline} />
                        <IonLabel>Suggest a business</IonLabel>
                    </IonItem>
                    <IonListHeader lines="none">
                        <IonCardSubtitle>Legal</IonCardSubtitle>
                    </IonListHeader>
                    <IonItem
                        routerDirection="forward"
                        onClick={()=>setShowPrivacy(true)}
                    >
                        <IonIcon slot="start" size="small"icon={lockClosedOutline} />
                        <IonLabel>Privacy Policy</IonLabel>
                    </IonItem>
                    <IonItem
                        routerDirection="forward"
                        onClick={()=>setShowTerms(true)}
                    >
                        <IonIcon slot="start" size="small"icon={documentOutline} />
                        <IonLabel>Terms of Service</IonLabel>
                    </IonItem>
                    <IonItem onClick={()=>logout()}>
                        <IonLabel color="danger">Logout</IonLabel>
                    </IonItem>
                </IonList>
                <IonModal
                    className={'rounded'}
                    isOpen={showPrivacy || showTerms}
                    initialBreakpoint={1}
                    breakpoints={[0, 1]}
                    onDidDismiss={() => setShowPrivacy(false)}
                >
                    {showPrivacy ? (
                    <Privacy onDismiss={() => setShowPrivacy(false)} />
                    ) : (
                    showTerms && <Terms onDismiss={() => setShowTerms(false)} />
                    )}
                </IonModal>
            </IonContent>
        </IonPage>
    );
};

export default Account;
